import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';

@Directive({
  selector: '[appDropZone]',
})
export class DropZoneDirective {
  @Output('appDropZone') fileDrop = new EventEmitter<Array<File>>();
  @Input() preventBodyDrop = true;
  @HostBinding('class.drop-zone-active')
  active = false;

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.active = false;

    const { dataTransfer } = event;

    if (dataTransfer!.items) {
      const files: any = [];
      for (let i = 0; i < dataTransfer!.items.length; i++) {
        if (dataTransfer!.items[i].kind === 'file') {
          var file = dataTransfer!.items[i].getAsFile();
          if (
            file!.type == 'image/png' ||
            file!.type == 'image/jpeg' ||
            file!.type == 'video/mp4' ||
            file!.type == 'video/avi' ||
            file!.type == 'video/x-matroska' ||
            file!.type == 'video/quicktime'
          ) {
            if (file!.size / 1024 / 1024 > 50) {
              forkJoin([
                this.translate.get('error'),
                this.translate.get('maximum_allowed_40_mb'),
              ]).subscribe((translate) => {
                this.toastr.error(translate[1], translate[0].toUpperCase());
              });
            } else {
              files.push(dataTransfer!.items[i].getAsFile());
            }
          } else {
            forkJoin([
              this.translate.get('error'),
              this.translate.get('jpg_png_mp4_avi_mkv_mov_files_only'),
            ]).subscribe((translate) => {
              this.toastr.error(translate[1], translate[0].toUpperCase());
            });
          }
        }
      }
      dataTransfer!.items.clear();
      this.fileDrop.emit(files);
    } else {
      const files = dataTransfer!.files;
      dataTransfer!.clearData();
      this.fileDrop.emit(Array.from(files));
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.active = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    this.active = false;
  }

  @HostListener('body:dragover', ['$event'])
  onBodyDragOver(event: DragEvent) {
    if (this.preventBodyDrop) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  @HostListener('body:drop', ['$event'])
  onBodyDrop(event: DragEvent) {
    if (this.preventBodyDrop) {
      event.preventDefault();
    }
  }

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}
}
